<template>
    <div>
        <img alt="Image" class="hero" src="../assets/OFX HeroSection.png" />
        <div class="container">
            <div class="row">
                <div class="col-sm">
                    <h5 class="text-left about">
                    </h5>
                    <hr />
                    <div class="d-flex pb-4">
                        <div class="contact-icon">
                            <img alt="Image" src="../assets/icon1.png" />
                        </div>
                        <div class="contact-info text-left">
                            <p>
                                <strong class="heading-level"
                                    >Thank you for your interest in the FDX API
                                    spec.</strong
                                ><br />
                                The receipt of the FDX API spec is contingent on
                                your acceptance, on behalf of xx, of the
                                <span class="target_links"
                                    >FDX Terms of Use, FDX API License
                                    Agreement</span
                                >
                                and FDX Privacy Policy. Please reply with your
                                acceptance, on behalf of xx, of T&C’s and FDX
                                will forward you the FDX API spec. <br />
                                <br />
                                <strong
                                    >We hope your firm joins as a standard
                                    member one day and will participate and
                                    influence the specifications in our working
                                    groups.</strong
                                >
                                By joining as a standard member, you will
                                receive many benefits available only to FDX
                                members, including:<br /><br />
                                • You will have the ability to shape/drive API
                                roadmap and forums to champion for your firm’s
                                needs;<br />
                                • Ability to cross pollinate ideas with other
                                200+ FDX members in semimonthly workgroups
                                ranging from security and data structures to
                                user experience and marketing;<br />
                                • Your company’s vote in any Working Group count
                                the same as each other firm (including the
                                largest);<br />
                                • Semiannual “developer meetups” Global Summit.
                                <br />
                                • Access to pre-release versions, supporting
                                artifacts, and tools;<br />
                                • Access to User Experience flow research/focus
                                groups and repositories of other members’
                                enrollment flows and dashboards;<br />
                                • Access to the contact information of all the
                                other member firms’ data sharing teams; and<br />
                                • Access to a community of SME’s in the Data
                                sharing space.
                            </p>
                            <hr />
                            <p>
                                <strong
                                    >By your acceptance of the T&Cs on behalf of
                                    your company, you represent to FDX
                                    that:</strong
                                ><br />
                                1. You have reviewed the T&Cs<br />
                                2. You have the authority to accept the T&Cs on
                                behalf of your company. <br />
                                3. Your company will be bound by your acceptance
                                thereof.<br />
                            </p>
                            <hr />
                            <p class="text-left body">
                                You will access the FDX API through our
                                <a
                                    href="https://developer.financialdataexchange.org/"
                                    target="_blank"
                                    rel="noopener"
                                    >FDX Developer Portal</a
                                >. <br /><br />
                                <strong
                                    >Your username and password is sent to your registered email. Please write to <a style="color: #019382">fdxsupport@financialdataexchange.org</a> if you have any questions.
                                </strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WelcomeToFdxAPI",
};
</script>

<style>
.heading1 {
    font-weight: 500;
    font-size: 74px;
    line-height: 87px;
    color: #d0ffff;
    margin-left: 100px;
}
.nav-tabs {
    border-bottom: none;
}
.lead {
    font-weight: 400;
    font-size: 35px;
    line-height: 41px;
    color: #ffffff;
    margin-left: 100px;
}
.hero {
    width: -webkit-fill-available;
    height: 400px;
}
/* .jumbotron{
background-image:url('../assets/Hero_img.png');
background-position: left;
} */
.about {
    font-weight: 500;
    font-size: 34px;
    line-height: 41px;
    color: #1978a0;
}
.contact-info {
    margin-left: 28px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
hr {
    border: 1px solid #d8d8d8;
}
p {
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
.heading-level {
    font-size: 18px;
    line-height: 24px;
}
.target_links {
    color: #019382;
    text-decoration: underline;
}
@media (max-width: 600px) {

    .hero {
        height: 250px !important;
    }

}
</style>
